// ─────────────────────────────────────────────────────────────────────────
// FormFrente.js — hoja inferior para crear un frente nuevo en "Mi tablero".
// El 409 del servidor (tope de activos) llega en `aviso` y se muestra tal cual.
// ─────────────────────────────────────────────────────────────────────────
import React, { useState } from "react";
import { AREAS, C, boton, campo, Hoja } from "./componentes";

const FormFrente = ({ onCerrar, onCrear, aviso }) => {
  const [f, setF] = useState({ area: "erp", titulo: "", siguienteAccion: "", quien: "maxi", plazo: "", accionCorta: false });
  const set = (k, v) => setF(p => ({ ...p, [k]: v }));
  const rot = { fontSize: 13, color: C.suave, margin: "10px 0 4px" };
  return (
    <Hoja onCerrar={onCerrar} cerrarConVelo={false}>
      <div style={{ fontSize: 20, fontWeight: 700 }}>Nuevo frente</div>
      <div style={rot}>Área</div>
      <select style={campo} value={f.area} onChange={e => set("area", e.target.value)}>
        {Object.entries(AREAS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
      </select>
      <div style={rot}>Título</div>
      <input style={campo} value={f.titulo} onChange={e => set("titulo", e.target.value)} />
      <div style={rot}>Siguiente acción</div>
      <textarea rows={2} style={{ ...campo, fontFamily: "inherit" }} value={f.siguienteAccion} onChange={e => set("siguienteAccion", e.target.value)} />
      <div style={rot}>Quién</div>
      <select style={campo} value={f.quien} onChange={e => set("quien", e.target.value)}>
        <option value="maxi">Maxi</option>
        <option value="agente">Agente</option>
        <option value="tercero">Tercero</option>
      </select>
      <div style={rot}>Plazo</div>
      <input type="date" style={campo} value={f.plazo} onChange={e => set("plazo", e.target.value)} />
      <label style={{ display: "flex", alignItems: "center", gap: 10, margin: "14px 0", minHeight: 44 }}>
        <input type="checkbox" style={{ width: 24, height: 24 }} checked={f.accionCorta} onChange={e => set("accionCorta", e.target.checked)} />
        Acción corta (menos de 10 minutos, solo yo)
      </label>
      {aviso && <div style={{ color: C.ambar, marginBottom: 10 }}>{aviso}</div>}
      <div style={{ display: "flex", gap: 8 }}>
        <button
          style={boton(C.verde, true)}
          disabled={!f.titulo.trim()}
          onClick={() => onCrear({ ...f, titulo: f.titulo.trim(), plazo: f.plazo || null })}
        >
          Crear
        </button>
        <button style={boton()} onClick={onCerrar}>Cancelar</button>
      </div>
    </Hoja>
  );
};

export default FormFrente;
